import React, { useEffect } from "react";
import QuizGame from "./QuizGame";
import Helmet from "react-helmet";
import "./QuizGame.css"; // Assuming you have some global styles
import QuizScale from "./component/QuizScale/QuizScale";
import QuizIframeCSS from "./component/QuizIframeCSS/QuizIframeCSS";
import { trackPageImpressionQuiz } from "./tracking/tracking";


function waitUntil(conditionFn, { intervalMs = 200, timeoutMs = 8000 } = {}) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    const t = setInterval(() => {
      try {
        if (conditionFn()) { clearInterval(t); resolve(); }
        else if (Date.now() - start >= timeoutMs) { clearInterval(t); reject(new Error("digitalData timeout")); }
      } catch (e) { clearInterval(t); reject(e); }
    }, intervalMs);
  });
}



export default function Page() {
  useEffect(() => {
    document.body.classList.add("transparent-body");
    return () => {
      document.body.classList.remove("transparent-body"); // Cleanup when unmounting
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        await waitUntil(() => Array.isArray(window?.digitalData?.events));

        const url = new URL(window.location.href);
        const toolname = url.searchParams.get("quiz") || "Niet-bekend";
        let toolshape = url.searchParams.get("shape") || "";
        if (!toolshape) {
          const questions = url.searchParams.getAll("question");
          if (questions.length) toolshape = questions.join("+");
        }

        trackPageImpressionQuiz({ boxname: toolname, pageid: toolshape, lang: "nl-BE" });
      } catch (e) {
        console.warn("[Analytics] digitalData not available:", e);
      }
    })();
  }, []);

  return (
    <div>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, user-scalable=no"
        />
        <title>EDUbox Quiz</title>
      </Helmet>

      {/* Voeg hier de QuizScale component toe */}
      <QuizScale>
        <QuizIframeCSS>
          <div id="quiz-container">
            <QuizGame />
          </div>
        </QuizIframeCSS>
      </QuizScale>
    </div>
  );
}
